document.addEventListener('DOMContentLoaded', function () {
  var slider = document.getElementById('contactInfoSlider');
  var dots = document.querySelectorAll('#sliderDots .slider-dot');

  if (!slider || !dots.length) return;

  function updateDots() {
    var cards = slider.querySelectorAll('.contact-info-box');
    var scrollLeft = slider.scrollLeft;
    var sliderWidth = slider.offsetWidth;
    var closest = 0;
    var minDist = Infinity;

    cards.forEach(function (card, i) {
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      var viewCenter = scrollLeft + sliderWidth / 2;
      var dist = Math.abs(cardCenter - viewCenter);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });

    dots.forEach(function (d, i) {
      d.classList.toggle('active', i === closest);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var index = parseInt(this.getAttribute('data-index'), 10);
      var cards = slider.querySelectorAll('.contact-info-box');
      if (!cards[index]) return;

      var targetLeft = cards[index].offsetLeft - 16;
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
    });
  });

  slider.addEventListener('scroll', updateDots, { passive: true });

  var isDragging = false;
  var startX = 0;
  var scrollStart = 0;

  slider.addEventListener('mousedown', function (e) {
    isDragging = true;
    startX = e.pageX;
    scrollStart = slider.scrollLeft;
    slider.classList.add('is-dragging');
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var delta = startX - e.pageX;
    slider.scrollLeft = scrollStart + delta;
  });

  document.addEventListener('mouseup', function () {
    if (!isDragging) return;
    isDragging = false;
    slider.classList.remove('is-dragging');
    updateDots();
  });
  updateDots();
});